import React, { useState, useEffect } from 'react'
import { NavLink } from 'react-router-dom'

export default function Home () {
  useEffect(() => {

  })
  return (
    <div class="bg-black">
      <h1 class="text-white">Hello World.</h1>
    </div>
  )
}
